<footer class="padding-top-15">
  <div class="container">
    <div class="row">
      <div class="col-md-6 left">
        <p>© Copyright 2020 - {{ currentYear }} <a href="mailto:billyinca@gmail.com">Bill Yin</a>.</p>
      </div>
      <div class="col-md-6 right">
        <p>Build by Angular.</p>
      </div>
    </div>
  </div>
</footer>
